(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flash-deals"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('flash-deals-timer')) {
    customElements.define(
      'flash-deals-timer',
      class FlashDealsTimer extends HTMLElement {
        connectedCallback() {
          this.hoursEl = this.querySelector('[data-hours]');
          this.minutesEl = this.querySelector('[data-minutes]');
          this.secondsEl = this.querySelector('[data-seconds]');
          this.tick = this.tick.bind(this);
          this.tick();
          this._timer = setInterval(this.tick, 1000);
        }

        disconnectedCallback() {
          if (this._timer) clearInterval(this._timer);
        }

        pad(value) {
          return String(value).padStart(2, '0');
        }

        remainingMs() {
          var now = new Date();
          var next = new Date(now);
          next.setHours(24, 0, 0, 0);
          var ms = next.getTime() - now.getTime();
          if (ms <= 0) {
            next.setDate(next.getDate() + 1);
            ms = next.getTime() - now.getTime();
          }
          return ms;
        }

        tick() {
          var total = Math.floor(this.remainingMs() / 1000);
          var hours = Math.floor(total / 3600);
          var minutes = Math.floor((total % 3600) / 60);
          var seconds = total % 60;
          if (this.hoursEl) this.hoursEl.textContent = this.pad(hours);
          if (this.minutesEl) this.minutesEl.textContent = this.pad(minutes);
          if (this.secondsEl) this.secondsEl.textContent = this.pad(seconds);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
